module.exports = __webpack_public_path__ + "static/img/register_doctor.3741979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register_doctor.jpg
// module id = NOvN
// module chunks = 7